import React, {
    useEffect,
    useRef,
    useState
}
from "react";


import evaImage
from "../images/eva_person.png";


import "./EvaChat.css";


import EvaConversation
from "./components/EvaConversation";


import EvaInput
from "./components/EvaInput";


import EvaVideo
from "./components/EvaVideo";


import {
    functions
}
from "../../../constants/common-functions";


import {
    STRINGIFY
}
from "../../../constants/general-constants";


//========================================================
// Eva Chat
//========================================================

export default function EvaChat({

    visible,
    onClose

})
{
	
	const EVA_VIDEO_ENABLED =
	    false;

    //----------------------------------------------------
    // State
    //----------------------------------------------------

    const [message, setMessage] =
        useState("");


    const [messages, setMessages] =
        useState([
            {
                role: "eva",
                text:
                    "Hello, I'm Eva. How can I help you today?"
            }
        ]);


    const [thinking, setThinking] =
        useState(false);


    const [listening, setListening] =
        useState(false);


    const [speaking, setSpeaking] =
        useState(false);


    //----------------------------------------------------
    // References
    //----------------------------------------------------

    const recognitionRef =
        useRef(null);


    const voiceConversationRef =
        useRef(false);


    const listeningRef =
        useRef(false);


    const speakingRef =
        useRef(false);


    const silenceTimerRef =
        useRef(null);


    const transcriptRef =
        useRef("");


    const evaVideoRef =
        useRef(null);


    //----------------------------------------------------
    // Voice Conversation Settings
    //----------------------------------------------------

    const SILENCE_DELAY =
        1500;


    const RESTART_DELAY =
        750;


    //----------------------------------------------------
    // Clear Silence Timer
    //----------------------------------------------------

    const clearSilenceTimer =
        () =>
        {

            if (silenceTimerRef.current)
            {

                clearTimeout(
                    silenceTimerRef.current
                );


                silenceTimerRef.current =
                    null;

            }

        };


    //----------------------------------------------------
    // Stop Listening
    //----------------------------------------------------

    const stopListening =
        () =>
        {

            clearSilenceTimer();


            listeningRef.current =
                false;


            setListening(
                false
            );


            if (recognitionRef.current)
            {

                try
                {

                    recognitionRef.current.stop();

                }
                catch(error)
                {

                    // Recognition may already be stopped.

                }

            }

        };


    //----------------------------------------------------
    // Start Listening
    //----------------------------------------------------

    const startListening =
        () =>
        {

            if (
                !voiceConversationRef.current ||
                !recognitionRef.current
            )
            {

                return;

            }


            //------------------------------------------------
            // Never Listen While Eva Is Speaking
            //------------------------------------------------

            if (speakingRef.current)
            {

                return;

            }


            //------------------------------------------------
            // Already Listening
            //------------------------------------------------

            if (listeningRef.current)
            {

                return;

            }


            //------------------------------------------------
            // Prepare New User Turn
            //------------------------------------------------

            clearSilenceTimer();


            transcriptRef.current =
                "";


            setMessage("");


            try
            {

                listeningRef.current =
                    true;


                setListening(
                    true
                );


                recognitionRef.current.start();

            }
            catch(error)
            {

                listeningRef.current =
                    false;


                setListening(
                    false
                );


                console.log(
                    "Eva microphone could not start.",
                    error
                );

            }

        };


    //====================================================
    // Speak Eva Response
    //====================================================

    const speak =
        async text =>
        {

            if (!text)
            {

                return;

            }


            //------------------------------------------------
            // Microphone Off While Eva Speaks
            //------------------------------------------------

            stopListening();


            speakingRef.current =
                true;


            setSpeaking(
                true
            );


            //------------------------------------------------
            // Remove Basic Markdown From Speech
            //------------------------------------------------

            const speechText =
                text
                    .replace(/\*\*/g, "")
                    .replace(/\*/g, "")
                    .replace(/#/g, "")
                    .replace(/`/g, "");


            try
            {

                //------------------------------------------------
                // Speak Through Simli
                //------------------------------------------------

                if (
                    evaVideoRef.current &&
                    evaVideoRef.current.speak
                )
                {

                    await evaVideoRef.current.speak(
                        speechText
                    );

                }
                else
                {

                    console.warn(
                        "Eva video is not ready to speak."
                    );

                }

            }
            catch(error)
            {

                console.error(
                    "Unable to make Eva speak.",
                    error
                );

            }
            finally
            {

                //------------------------------------------------
                // Eva Has Finished Sending Speech
                //------------------------------------------------
                //
                // At this stage the PCM has been sent to Simli.
                // We deliberately do not use browser speech
                // synthesis any more.
                //------------------------------------------------

                speakingRef.current =
                    false;


                setSpeaking(
                    false
                );


                //------------------------------------------------
                // Resume Voice Conversation
                //------------------------------------------------

                if (
                    voiceConversationRef.current
                )
                {

                    setTimeout(
                        function()
                        {

                            if (
                                voiceConversationRef.current &&
                                !speakingRef.current
                            )
                            {

                                startListening();

                            }

                        },
                        RESTART_DELAY
                    );

                }

            }

        };


    //----------------------------------------------------
    // Send Message
    //----------------------------------------------------

    const sendMessage =
        (
            messageOverride,
            voiceRequest = false
        ) =>
        {

            const userMessage =
                (
                    typeof messageOverride === "string"
                        ?
                        messageOverride
                        :
                        message
                ).trim();


            if (
                !userMessage ||
                thinking
            )
            {

                return;

            }


            //------------------------------------------------
            // Add User Message
            //------------------------------------------------

            setMessages(
                current => [
                    ...current,
                    {
                        role: "user",
                        text: userMessage
                    }
                ]
            );


            setMessage("");


            setThinking(
                true
            );


            //------------------------------------------------
            // Ask OmniScan Eva
            //------------------------------------------------

            functions.submitAjax(

                "/resolutionsoftwareplatform/eva/chat",

                {
                    message:
                        userMessage
                },

                function(data)
                {

                    //------------------------------------------------
                    // Eva Response
                    //------------------------------------------------

                    if (
                        data &&
                        data.message
                    )
                    {

                        setMessages(
                            current => [
                                ...current,
                                {
                                    role: "eva",
                                    text:
                                        data.message
                                }
                            ]
                        );


                        setThinking(
                            false
                        );


                        //------------------------------------------------
                        // Speak Real Eva Response
                        //------------------------------------------------
                        //
                        // Both typed and voice questions now receive
                        // the same visual/avatar response.
                        //------------------------------------------------

                        speak(
                            data.message
                        );

                    }
                    else
                    {

                        const errorMessage =
                            "Sorry, I couldn't respond just then.";


                        setMessages(
                            current => [
                                ...current,
                                {
                                    role: "eva",
                                    text:
                                        errorMessage
                                }
                            ]
                        );


                        setThinking(
                            false
                        );


                        //------------------------------------------------
                        // Resume Listening
                        //------------------------------------------------

                        if (
                            voiceRequest &&
                            voiceConversationRef.current
                        )
                        {

                            setTimeout(
                                function()
                                {

                                    startListening();

                                },
                                RESTART_DELAY
                            );

                        }

                    }

                },

                STRINGIFY

            );

        };


    //----------------------------------------------------
    // Finish User Speech
    //----------------------------------------------------

    const finishUserSpeech =
        () =>
        {

            clearSilenceTimer();


            const transcript =
                transcriptRef.current.trim();


            if (!transcript)
            {

                return;

            }


            //------------------------------------------------
            // Stop Microphone
            //------------------------------------------------

            stopListening();


            setMessage("");


            //------------------------------------------------
            // Send To Eva
            //------------------------------------------------

            sendMessage(
                transcript,
                true
            );

        };


    //----------------------------------------------------
    // Speech Recognition
    //----------------------------------------------------

    useEffect(

        function()
        {

            const SpeechRecognition =
                window.SpeechRecognition ||
                window.webkitSpeechRecognition;


            if (!SpeechRecognition)
            {

                console.log(
                    "Speech recognition is not supported."
                );


                return;

            }


            const recognition =
                new SpeechRecognition();


            recognition.continuous =
                true;


            recognition.interimResults =
                true;


            recognition.lang =
                "en-GB";


            //------------------------------------------------
            // Speech Result
            //------------------------------------------------

            recognition.onresult =
                function(event)
                {

                    if (
                        speakingRef.current ||
                        !voiceConversationRef.current
                    )
                    {

                        return;

                    }


                    let finalTranscript =
                        "";


                    let interimTranscript =
                        "";


                    for (
                        let i = event.resultIndex;
                        i < event.results.length;
                        i++
                    )
                    {

                        const resultTranscript =
                            event.results[i][0].transcript;


                        if (
                            event.results[i].isFinal
                        )
                        {

                            finalTranscript +=
                                resultTranscript;

                        }
                        else
                        {

                            interimTranscript +=
                                resultTranscript;

                        }

                    }


                    //------------------------------------------------
                    // Store Final Speech
                    //------------------------------------------------

                    if (finalTranscript.trim())
                    {

                        transcriptRef.current +=
                            (
                                transcriptRef.current
                                    ?
                                    " "
                                    :
                                    ""
                            ) +
                            finalTranscript.trim();

                    }


                    //------------------------------------------------
                    // Show What Eva Heard
                    //------------------------------------------------

                    const displayTranscript =
                        (
                            transcriptRef.current +
                            (
                                interimTranscript.trim()
                                    ?
                                    " " +
                                    interimTranscript.trim()
                                    :
                                    ""
                            )
                        ).trim();


                    setMessage(
                        displayTranscript
                    );


                    //------------------------------------------------
                    // Wait For User To Finish Speaking
                    //------------------------------------------------

                    clearSilenceTimer();


                    silenceTimerRef.current =
                        setTimeout(
                            function()
                            {

                                finishUserSpeech();

                            },
                            SILENCE_DELAY
                        );

                };


            //------------------------------------------------
            // Recognition Ended
            //------------------------------------------------

            recognition.onend =
                function()
                {

                    listeningRef.current =
                        false;


                    setListening(
                        false
                    );

                };


            //------------------------------------------------
            // Recognition Error
            //------------------------------------------------

            recognition.onerror =
                function(error)
                {

                    console.error(
                        "Eva microphone error",
                        error
                    );


                    listeningRef.current =
                        false;


                    setListening(
                        false
                    );


                    if (
                        error.error !== "no-speech" &&
                        error.error !== "aborted"
                    )
                    {

                        voiceConversationRef.current =
                            false;

                    }

                };


            recognitionRef.current =
                recognition;


            //------------------------------------------------
            // Cleanup
            //------------------------------------------------

            return function()
            {

                clearSilenceTimer();


                voiceConversationRef.current =
                    false;


                listeningRef.current =
                    false;


                speakingRef.current =
                    false;


                try
                {

                    recognition.stop();

                }
                catch(error)
                {

                    // Recognition already stopped.

                }

            };

        },

        []

    );


    //----------------------------------------------------
    // Toggle Microphone
    //----------------------------------------------------

    const toggleMicrophone =
        () =>
        {

            if (!recognitionRef.current)
            {

                return;

            }


            //------------------------------------------------
            // End Voice Conversation
            //------------------------------------------------

            if (voiceConversationRef.current)
            {

                voiceConversationRef.current =
                    false;


                speakingRef.current =
                    false;


                setSpeaking(
                    false
                );


                stopListening();


                transcriptRef.current =
                    "";


                setMessage("");


                return;

            }


            //------------------------------------------------
            // Start Voice Conversation
            //------------------------------------------------

            speakingRef.current =
                false;


            setSpeaking(
                false
            );


            voiceConversationRef.current =
                true;


            transcriptRef.current =
                "";


            setMessage("");


            startListening();

        };


    //----------------------------------------------------
    // Typed Message
    //----------------------------------------------------

    const handleSend =
        () =>
        {

            sendMessage(
                undefined,
                false
            );

        };


    //----------------------------------------------------
    // Clear Conversation
    //----------------------------------------------------

    const clearConversation =
        () =>
        {

            voiceConversationRef.current =
                false;


            speakingRef.current =
                false;


            setSpeaking(
                false
            );


            stopListening();


            clearSilenceTimer();


            transcriptRef.current =
                "";


            setMessage("");


            setMessages([
                {
                    role: "eva",
                    text:
                        "Hello, I'm Eva. How can I help you today?"
                }
            ]);

        };


    //----------------------------------------------------
    // Close Eva
    //----------------------------------------------------

    const closeEva =
        () =>
        {

            voiceConversationRef.current =
                false;


            speakingRef.current =
                false;


            setSpeaking(
                false
            );


            stopListening();


            transcriptRef.current =
                "";


            setMessage("");


            if (onClose)
            {

                onClose();

            }

        };


    //----------------------------------------------------
    // Render
    //----------------------------------------------------

    return (

        <>

            {/*============================================
                Backdrop
            ============================================*/}

            <div
                className={
                    "eva-chat-backdrop " +
                    (
                        visible
                            ?
                            "eva-chat-backdrop-visible"
                            :
                            ""
                    )
                }

                onClick={
                    closeEva
                }
            />


            {/*============================================
                Drawer
            ============================================*/}

            <div
                className={
                    "eva-chat-drawer " +
                    (
                        visible
                            ?
                            "eva-chat-drawer-visible"
                            :
                            ""
                    )
                }
            >

                {/*========================================
                    Header
                ========================================*/}

                <div
                    className="eva-chat-header"
                >

                    <button
                        className="eva-chat-clear"
                        onClick={clearConversation}
                        type="button"
                        title="Clear conversation"
                    >
                        Clear
                    </button>


                    <button
                        className="eva-chat-close"
                        onClick={closeEva}
                        type="button"
                    >
                        ×
                    </button>


                    <div
                        className={
                            "eva-chat-avatar-shell " +
                            (
                                thinking
                                    ?
                                    "eva-chat-avatar-thinking"
                                    :
                                    ""
                            )
                        }
                    >

                        <img
                            src={evaImage}
                            className="eva-chat-avatar"
                            alt="Eva"
                        />

                    </div>


                    <div
                        className="eva-chat-name"
                    >
                        Eva
                    </div>


                    <div
                        className="eva-chat-subtitle"
                    >
                        Your Intelligent Estate Assistant
                    </div>

                </div>


                {/*========================================
                    Conversation
                ========================================*/}

                <EvaConversation
                    messages={messages}
                    thinking={thinking}
                    evaImage={evaImage}
                />


                {/*========================================
                    Input
                ========================================*/}

                <EvaInput
                    message={message}
                    setMessage={setMessage}
                    thinking={thinking}
                    listening={listening}
                    speaking={speaking}
                    voiceConversationActive={
                        voiceConversationRef.current
                    }
                    onSend={handleSend}
                    onToggleMicrophone={toggleMicrophone}
                />

            </div>


            {/*============================================
                Simli Live Eva
            ============================================*/}

			{EVA_VIDEO_ENABLED &&
			    <EvaVideo
			        ref={evaVideoRef}
			        visible={visible}
			    />
			}

        </>

    );

}